(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["battery-features"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('section.battery-features');
    if (!sections.length) return;

    var selector = '.battery-features__feature-title, .battery-features__feature-description';
    var pattern = /(\b\d+\s*Min\b)/gi;

    sections.forEach(function(section){
      var nodes = section.querySelectorAll(selector);
      nodes.forEach(function(el) {
        if (el.dataset.accentApplied === 'true') return;
        var html = el.innerHTML;
        if (!html) return;
        html = html.replace(pattern, '<span class="accent">$1</span>');
        el.innerHTML = html;
        el.dataset.accentApplied = 'true';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ins-anchor-blocks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const blocks = document.querySelectorAll('.ins-anchor-blocks__block');
    const observerOptions = {
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        const element = entry.target;
        const isAnimating = element.dataset.animating === 'true';
        const animatedOnce = element.dataset.animatedOnce === 'true';

        if (entry.isIntersecting && !isAnimating && (!animatedOnce || window.innerWidth >= 1024)) {
          element.dataset.animating = 'true';
          element.classList.add('fade-in');
          element.classList.remove('fade-out');
          setTimeout(() => {
            element.dataset.animating = 'false';
            if (window.innerWidth < 1024) {
              element.dataset.animatedOnce = 'true';
              observer.unobserve(element);
            }
          }, 300);
        } else if (!entry.isIntersecting && !isAnimating && window.innerWidth >= 1024) {
          element.dataset.animating = 'true';
          element.classList.add('fade-out');
          element.classList.remove('fade-in');
          setTimeout(() => {
            element.dataset.animating = 'false';
          }, 300);
        }
      });
    }, observerOptions);

    blocks.forEach((block) => {
      observer.observe(block);

      // 悬停效果
      block.addEventListener('mouseenter', () => {
        const link = block.querySelector('.ins-anchor-block__link');
        if (link) {
          link.classList.add('hover');
        }
      });

      block.addEventListener('mouseleave', () => {
        const link = block.querySelector('.ins-anchor-block__link');
        if (link) {
          link.classList.remove('hover');
        }
      });

      // 移动端触摸效果
      if ('ontouchstart' in window) {
        block.addEventListener('touchstart', () => {
          block.classList.add('touch-active');
        });
        
        block.addEventListener('touchend', () => {
          setTimeout(() => {
            block.classList.remove('touch-active');
          }, 150);
        });
        
        block.addEventListener('touchcancel', () => {
          block.classList.remove('touch-active');
        });
      }

      // 点击整个block跳转
      block.addEventListener('click', (e) => {
        // 若点击来自链接本身（整卡片覆盖的 a），避免重复触发
        if (e.target && e.target.closest && e.target.closest('.ins-anchor-block__link')) {
          return;
        }
        const link = block.querySelector('.ins-anchor-block__link');
        if (link) {
          link.click();
        }
      });

      // 设置移动端背景图片（桌面端现在使用静态CSS）
      let desktopImage = block.dataset.desktopImage;
      let mobileImage = block.dataset.mobileImage;
      
      // 修复HTML实体编码问题
      if (desktopImage) {
        desktopImage = desktopImage.replace(/&amp;/g, '&');
      }
      if (mobileImage) {
        mobileImage = mobileImage.replace(/&amp;/g, '&');
      }

      // 图片URL验证函数
      function isValidImageUrl(url) {
        if (!url || url === '' || url === 'undefined' || url.includes('undefined')) {
          console.log('❌ 无效URL:', url);
          return false;
        }
        
        // 更宽松的验证条件，特别支持 Shopify CDN
        const validPrefixes = ['http://', 'https://', '/', './'];
        const hasValidPrefix = validPrefixes.some(prefix => url.startsWith(prefix));
        const hasImageIndicator = /\.(jpg|jpeg|png|gif|webp|svg)(\?|$)|\/cdn\/shop\/|shopify:\/\//.test(url);
        
        const isValid = hasValidPrefix && hasImageIndicator;
        console.log(`🔍 URL验证 "${url}": ${isValid ? '✅ 有效' : '❌ 无效'}`);
        return isValid;
      }

      function updateMobileBackgroundImage() {
        console.log(`📱 updateMobileBackgroundImage 调用 - 屏幕宽度: ${window.innerWidth}px`);
        console.log(`📸 原始图片数据 - Desktop: "${desktopImage}", Mobile: "${mobileImage}"`);
        
        // 只处理移动端背景图片，桌面端由CSS静态处理
        if (window.innerWidth < 1025) {
          if (isValidImageUrl(mobileImage)) {
            const imageUrl = `url(${mobileImage})`;
            block.style.setProperty('--mobile-bg-image', imageUrl);
            console.log('✅ 设置移动端背景图片:', imageUrl);
            
            // 验证CSS变量是否设置成功
            const actualValue = getComputedStyle(block).getPropertyValue('--mobile-bg-image');
            console.log('🔍 CSS变量实际值:', actualValue);
          } else if (isValidImageUrl(desktopImage)) {
            // 如果没有移动端图片，使用桌面端图片作为备用
            const imageUrl = `url(${desktopImage})`;
            block.style.setProperty('--mobile-bg-image', imageUrl);
            console.log('✅ 使用桌面端图片作为移动端备用:', imageUrl);
          } else {
            block.style.removeProperty('--mobile-bg-image');
            console.log('❌ 清除移动端背景图片 - 无有效图片');
            console.log('❌ Desktop图片验证失败:', desktopImage);
            console.log('❌ Mobile图片验证失败:', mobileImage);
          }
        } else {
          // 桌面端清除移动端CSS变量
          block.style.removeProperty('--mobile-bg-image');
          console.log('🖥️ 桌面端模式 - 使用静态CSS背景图片');
        }
      }

      // 现在移动端主要依靠静态CSS，JavaScript作为调试和备用
      // 初始化（主要用于调试）
      if (window.innerWidth < 1025) {
        console.log('📱 移动端模式 - 主要使用静态CSS，JavaScript仅作调试');
        updateMobileBackgroundImage();
      }
      
      // 监听屏幕尺寸变化
      window.addEventListener('resize', updateMobileBackgroundImage);
    });

    // 调试信息 - 显示图片处理方式
    console.log('📋 ins-anchor-blocks 初始化完成');
    console.log('📊 总共找到', blocks.length, '个卡片');
    console.log('🖥️ 桌面端：使用静态CSS背景图片（::after伪元素 + hover放大效果）');
    console.log('📱 移动端：使用静态CSS背景图片（::before伪元素 + touch放大效果）');
    console.log('🔧 JavaScript：用于调试、动态resize处理和触摸事件');
    
    blocks.forEach((block, index) => {
      const rawDesktopImage = block.dataset.desktopImage;
      const rawMobileImage = block.dataset.mobileImage;
      
      console.log(`📦 卡片 ${index + 1}:`, { 
        hasDesktopImage: !!rawDesktopImage,
        hasMobileImage: !!rawMobileImage,
        desktopImageMethod: '静态CSS',
        mobileImageMethod: 'JavaScript CSS变量',
        rawDesktopImage: rawDesktopImage,
        rawMobileImage: rawMobileImage
      });
      
      // 立即检查移动端是否有背景图片
      if (window.innerWidth < 1025) {
        setTimeout(() => {
          const computedStyle = getComputedStyle(block, '::before');
          const bgImage = computedStyle.getPropertyValue('background-image');
          console.log(`🔍 卡片 ${index + 1} 移动端背景图片检查:`, {
            cssVariable: getComputedStyle(block).getPropertyValue('--mobile-bg-image'),
            actualBackgroundImage: bgImage,
            isImageSet: bgImage && bgImage !== 'none'
          });
        }, 200);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-youtube-video"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function() {
        let button_label_button = document.querySelector(".button_label_button");
        if(button_label_button){
            button_label_button.addEventListener("click", function(){
                console.log('===as');
                
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ 'event_parameters': null });
                window.dataLayer.push({
                    'event':'ga4Event',
                    'event_name':'select_content',
                    'event_parameters':{
                        'content_name':'{{ section.settings.heading }}',
                        'button_name':'{{ section.settings.button_label }}'
                    }
                })
            })
        }
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var productsRows = document.querySelectorAll('.products-row');
    productsRows.forEach(function(row) {
      new Flickity(row, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: false
      });
    });

    //init flickity for each .media-slider
    var mediaSliders = document.querySelectorAll('.media-slider');
    mediaSliders.forEach(function(slider) {
      new Flickity(slider, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        autoPlay: 5000,
        pauseAutoPlayOnHover: true,
        wrapAround: true
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-airflow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const popup = document.querySelector('.airflow-popup');
    const trigger = document.querySelector('.mini-airflow-trigger');
    const overlay = document.querySelector('.airflow-popup .popup-overlay');
    const close = document.querySelector('.airflow-popup .popup-close');

    trigger.addEventListener('click', function () {
      popup.classList.add('open');
    });

    overlay.addEventListener('click', function () {
      popup.classList.remove('open');
    });

    close.addEventListener('click', function () {
      popup.classList.remove('open');
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-child-mode"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        var popupTrigger = document.querySelector('.child-mode-popup-trigger');
        var popup = document.querySelector('.child-mode-popup');
        var popupOverlay = document.querySelector('.child-mode-popup .popup-overlay');
        var popupClose = document.querySelector('.child-mode-popup .popup-close');

        popupTrigger.addEventListener('click', function(){
            popup.classList.add('open');
        });

        popupOverlay.addEventListener('click', function(){
            popup.classList.remove('open');
        });

        popupClose.addEventListener('click', function(){
            popup.classList.remove('open');
        });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-colors"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function(){
    const miniColors = document.querySelectorAll('.mini-color');
    const miniColorTitle = document.querySelector('.mini-color-title');

    miniColors.forEach(miniColor => {
        miniColor.addEventListener('click', function(){
            const index = this.getAttribute('data-index');
            miniColors.forEach(miniColor => miniColor.classList.remove('is-active'));
            this.classList.add('is-active');
            document.querySelectorAll('.mini-colors-image img').forEach(image => image.style.display = 'none');
            document.querySelector(`.mini-colors-image img:nth-child(${index})`).style.display = 'block';
            miniColorTitle.innerHTML = this.getAttribute('data-title');
        });
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-hairdryer-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    const hairdryerBanner = $('.mini-hairdryer-banner');
    const endPoint = $(window).outerHeight() * 3;
    const tagline_image = $('.tagline-image');
    const banner_product = $('.banner-product');
    const banner_product_info = $('.banner-product-info');
    const banner_features = $('.mini-banner-features');
    const banner_features_inner = $(".mini-banner-features .features-list");
    const banner_features_items = $(".mini-banner-features .feature");

    let bannerTl;
    function miniHdBanner() {
      if (bannerTl) bannerTl.revert();
      bannerTl = gsap.timeline({
        scrollTrigger: {
          trigger: hairdryerBanner,
          start: 'top top',
          end: () => `${endPoint} bottom`,
          pin: true,
          scrub: true,
          invalidateOnRefresh: true
        },
      });
      bannerTl.fromTo(tagline_image,
        { 
          x: -200, 
          opacity: 0 
        },
        { 
          x: -10, 
          opacity: 1, 
          ease: 'none',
          duration: 2
        }
      )
      bannerTl.fromTo(banner_product,
        { 
          opacity: 0 
        },
        { 
          opacity: 1, 
          ease: 'none',
          duration: 2,
          delay: 5 
        }
      )
      bannerTl.fromTo(banner_product_info,
        { 
          opacity: 0 
        },
        { 
          opacity: 1, 
          ease: 'none',
          duration: 2,
          onStart: function(){
            banner_product.addClass('appear');
          },
          onReverseComplete: function(){
            banner_product.removeClass('appear');
          } 
        }
      )
      bannerTl.to(banner_product_info,{
        yPercent: -100,
        opacity: 0,
        duration: 10,
        delay: 5 
      })
      bannerTl.fromTo(banner_features,
        { 
          opacity: 0 
        },
        { 
          opacity: 1, 
          ease: 'none'
        },
        "-=7"
      )
      bannerTl.fromTo(banner_features_inner,
        { 
          yPercent: 100, 
        },
        { 
          yPercent: -50, 
          ease: 'none',
          duration: 10,
        },
        "-=12"
      )

      bannerTl.fromTo(banner_features_items, 
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 4,
                stagger: 2
            },
            "-=10"
        )

    }
    let lw;
    window.addEventListener('resize', function () {
      if (lw != window.innerWidth) {
        if (bannerTl) {
          bannerTl.revert();
          bannerTl.clear();
        }
        miniHdBanner();
      }
      lw = window.innerWidth;
    });
    miniHdBanner();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-hotspot"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    const hotspots = document.querySelectorAll('.hotspot');
    const popups = document.querySelectorAll('.hotspot-popup');
    const popupClose = document.querySelectorAll('.popup-close');
    hotspots.forEach(hotspot => {
      hotspot.addEventListener('click', function(){
        const id = this.getAttribute('data-id');
        const popup = document.querySelector(`.hotspot-popup[data-id="${id}"]`);
        popup.classList.add('open');
      });
    });
    popups.forEach(popup => {
      popup.addEventListener('click', function(){
        this.classList.remove('open');
      });
    });
    popupClose.forEach(close => {
      close.addEventListener('click', function(e){
        e.stopPropagation();
        this.closest('.hotspot-popup').classList.remove('open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-image-slider"] && !Shopify.designMode) return;
  try {
    
    const miniImageSlider = new Flickity('.mini-image-slider', {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        pageDots: true,
        groupCells: true,
        prevNextButtons: true
    });

    let start = null;
    let duration = 5000;
    function updateDot(time){
      if(!start) start = time;
      let progress = time - start;
      let scaleX = progress / duration;
      $('.mini-image-slider .flickity-page-dots')[0].style.setProperty('--scaleX', scaleX);
      if(progress < duration){
        requestAnimationFrame(updateDot);
      }else{
        start = null;
        miniImageSlider.next();
        $('.mini-image-slider .flickity-page-dots')[0].style.setProperty('--scaleX', 0);
        requestAnimationFrame(updateDot);
      }
    }
    requestAnimationFrame(updateDot);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-size-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    const miniSizeSection = $('.mini-size-details');
    const sizeText = miniSizeSection.find('.mini-size-text');
    const endPoint = $(window).outerHeight() * 2;

    const lengthLine1 = miniSizeSection.find('.length-lines span:nth-child(1)');
    const lengthLine2 = miniSizeSection.find('.length-lines span:nth-child(2)');
    const lengthLine3 = miniSizeSection.find('.length-lines span:nth-child(3)');
    const lengthValue = miniSizeSection.find('.length-value');
    
    const heightLine1 = miniSizeSection.find('.height-lines span:nth-child(1)');
    const heightLine2 = miniSizeSection.find('.height-lines span:nth-child(2)');
    const heightLine3 = miniSizeSection.find('.height-lines span:nth-child(3)');
    const heightValue = miniSizeSection.find('.height-value');

    let sizeTL;
    function miniSize() {
      if (sizeTL) sizeTL.revert();
      sizeTL = gsap.timeline({
        scrollTrigger: {
          trigger: miniSizeSection,
          start: 'top top',
          end: () => `+=${endPoint}`,
          anticipatePin: 1,
          pin: true,
          scrub: true,
          invalidateOnRefresh: true
        },
      });
      sizeTL.fromTo(sizeText,
        {
          opacity: 1
        },
        {
          opacity: 0,
          duration: 1
        }
      );
      sizeTL.fromTo(lengthLine1,
        {
          scaleY: 0
        },
        {
          scaleY: 1,
          duration: 1
        },
        '<'
      );
      sizeTL.fromTo(heightLine1,
        {
          scaleX: 0
        },
        {
          scaleX: 1,
          duration: 1
        },
        '<'
      );
      sizeTL.fromTo(lengthLine2,
        {
          scaleX: 0
        },
        {
          scaleX: 1,
          duration: 1
        }
      );
      sizeTL.fromTo(heightLine2,
        {
          scaleY: 0
        },
        {
          scaleY: 1,
          duration: 1
        },
        '<'
      );
      sizeTL.fromTo(lengthLine3,
        {
          scaleY: 0
        },
        {
          scaleY: 1,
          duration: 1
        }
      );
      sizeTL.fromTo(heightLine3,
        {
          scaleX: 0
        },
        {
          scaleX: 1,
          duration: 1
        },
        '<'
      );
      sizeTL.fromTo(lengthValue,
        {
          opacity: 0
        },
        {
          opacity: 1,
          duration: 1
        },
        '<'
      );
      sizeTL.fromTo(heightValue,
        {
          opacity: 0
        },
        {
          opacity: 1,
          duration: 1
        },
        '<'
      );
    }
    let lw;
    window.addEventListener('resize', function () {
      if (lw != window.innerWidth) {
        if (sizeTL) {
          sizeTL.revert();
          sizeTL.clear();
        }
        miniSize();
      }
      lw = window.innerWidth;
    });
    miniSize();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-weight"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    const miniWeightSection = $('.mini-weight-section');
    const endPoint = $(window).outerHeight() * 2;
    const mini_weight_text_1 = miniWeightSection.find('.mini-weight-text-1');
    const mini_weight_text_2 = miniWeightSection.find('.mini-weight-text-2');
    const mini_weight_text_footer = miniWeightSection.find('.mini-weight-text-footer');

    let weightTl;
    function miniWeightBanner() {
      if (weightTl) weightTl.revert();
      weightTl = gsap.timeline({
        scrollTrigger: {
          trigger: miniWeightSection,
          start: 'top top',
          end: () => `+=${endPoint} bottom`,
          anticipatePin: 1,
          scrub: true,
          invalidateOnRefresh: true
        },
      });
      weightTl.fromTo(mini_weight_text_1,
        { 
          opacity: 0 
        },
        { 
          opacity: 1, 
          ease: 'none',
          duration: 2
        }
      ).fromTo(mini_weight_text_footer,
        { 
          opacity: 0 
        },
        { 
          opacity: 1, 
          ease: 'none',
          duration: 2
        },
        '<'
      ).to(mini_weight_text_1,
        { 
          opacity: 0, 
          ease: 'none',
          duration: 2,
          delay: 3
        }
      );
      weightTl.fromTo(mini_weight_text_2,
        { 
          opacity: 0 
        },
        { 
          opacity: 1, 
          ease: 'none',
          duration: 2
        },
        '-=1'
      )

    }
    let lw;
    window.addEventListener('resize', function () {
      if (lw != window.innerWidth) {
        if (weightTl) {
            weightTl.revert();
            weightTl.clear();
        }
        miniWeightBanner();
      }
      lw = window.innerWidth;
    });
    miniWeightBanner();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pillar-banner-v4"] && !Shopify.designMode) return;
  try {
    
$('.pillar-banner-hotspot button').on('click', function(){
    const content = $(this).closest('.pillar-banner-hotspot').find('.hotspot-popup-content').html();
    $('.pillar-banner-hotspot button').not(this).removeClass('active');
    $(this).toggleClass('active');
    $(this).closest('.pillar-banner-hotspots').find('.hotspot-popup').html(content);
    if($(this).hasClass('active')){
        $(this).closest('.pillar-banner-hotspots').find('.hotspot-popup').addClass('active');
    }else{
        $(this).closest('.pillar-banner-hotspots').find('.hotspot-popup').removeClass('active');
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popular-categories"] && !Shopify.designMode) return;
  try {
    
  var flkty = new Flickity('.categories-flex', {
    cellAlign: 'left',
    contain: true,
    prevNextButtons: false,
    pageDots: false
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toothbrush-comparison"] && !Shopify.designMode) return;
  try {
    
$('.color-swatch').click(function(){
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    const index = $(this).index();
    const parent = $(this).parents('.wave-product-column');
    const activeProduct = parent.find('.wave-product').eq(index);
    const url = activeProduct.data('url');
    activeProduct.addClass('active').siblings().removeClass('active');
    parent.find('.wave-product-button a').attr('href', url);
});

  } catch(e) { console.error(e); }
})();
})();
